import React from 'react'
import { AdminAddProduct } from '../../../../../Components/Views'

const Render = () => {
    return (
        <AdminAddProduct />
    )
}

export default Render